import {
  reResponsiblesExecutPositionConstants
} from './constants'
import api from './api';
import { defAction } from '../../../helpers/defaultAction';

export const reResponsibleExecutPositionActions = {
  getResponsiblesExecutPosition,
  getResponsibleExecutPositionByName,
  createResponsibleExecutPosition,
  deleteResponsibleExecutPosition,
  updateResponsibleExecutPosition,
  restoreResponsibleExecutPosition,
  clearResponsibleExecutPosition
}

function getResponsiblesExecutPosition(params) {
  return dispatch => {
    dispatch(request())

    api.getResponsiblesExecutPosition(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_REQUEST
      }
    }
    function success(respExecPos) {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_SUCCESS,
        payload: respExecPos
      }
    }
    function failure(error) {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_FAILURE,
        payload: error
      }
    }
  }
}

function getResponsibleExecutPositionByName(params) {
  return dispatch => {
    dispatch(request())

    api.getResponsibleExecutPositionByName(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_REQUEST
      }
    }
    function success(respExecPos) {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_SUCCESS,
        payload: respExecPos
      }
    }
    function failure(error) {
      return {
        type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_FAILURE,
        payload: error
      }
    }
  }
}
function createResponsibleExecutPosition(params) {
  const dispatchObj = {
    constants: reResponsiblesExecutPositionConstants.createResponsibleExecutPosition,
    service: {
      func: api.createResponsibleExecutPosition,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function deleteResponsibleExecutPosition(params) {
  const dispatchObj = {
    constants: reResponsiblesExecutPositionConstants.deleteResponsibleExecutPosition,
    service: {
      func: api.deleteResponsibleExecutPosition,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function updateResponsibleExecutPosition(params) {
  const dispatchObj = {
    constants: reResponsiblesExecutPositionConstants.updateResponsibleExecutPosition,
    service: {
      func: api.updateResponsibleExecutPosition,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function restoreResponsibleExecutPosition(params) {
  const dispatchObj = {
    constants: reResponsiblesExecutPositionConstants.restoreResponsibleExecutPosition,
    service: {
      func: api.restoreResponsibleExecutPosition,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function clearResponsibleExecutPosition() {
  return (dispatch) =>
  dispatch({
    type: reResponsiblesExecutPositionConstants.SEND_RERESPONSIBLESEXECUTPOSITION_CLEAR,
  })
}